import React from "react";
import { Input as AntInput } from "antd";
import PropTypes from "prop-types";

import "./Input.css";
import { useTranslation } from "react-i18next";

const Input = (props) => {
  const { allowClear = true } = props;
  const { i18n } = useTranslation();

  return (
    <div
      className={
        props.className ? `helbest-input ${props.className}` : "helbest-input"
      }
    >
      {props.label ? (
        <label className="input-label">{props.label}</label>
      ) : null}
      <AntInput
        allowClear={allowClear}
        className="simple-input"
        bordered={false}
        dir="auto"
        defaultValue={props.defaultValue || ""}
        maxLength={props.maxLength ? props.maxLength : null}
        minLength={props.minLength ? props.minLength : null}
        type={props.type ? props.type : null}
        disabled={props.disabled ? props.disabled : null}
        placeholder={props.placeholder ? props.placeholder : null}
        value={props.data}
        pattern={props.pattern}
        inputMode={props.inputMode}
        onBlur={props.onBlur}
        onChange={(e) =>
          props.dataHandler ? props.dataHandler(e.target.value) : null
        }
      />
    </div>
  );
};

Input.propTypes = {
  allowClear: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  data: PropTypes.string,
  dataHandler: PropTypes.func,
  onBlur: PropTypes.func,
  maxLength: PropTypes.number,
  minLength: PropTypes.number,
  onFull: PropTypes.func,
  className: PropTypes.string,
  defaultValue: PropTypes.string,
};
export default Input;
